// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-add-to-queue[data-v-7aea1f35]{min-width:90px}", "",{"version":3,"sources":["webpack://./resources/js/components/pages/registration/partials/UserSearchResults.vue"],"names":[],"mappings":"AACA,mCACE,cAAF","sourcesContent":["\n.btn-add-to-queue {\n  min-width: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
